export default __webpack_public_path__ + "static/media/expl-nn_01_EN.42ac49ff.png";